import React from 'react';
import ReactCountryFlag from 'react-country-flag';

import { StyledFlag } from './Flag.styles';

import { FlagProps } from './Flag.types';

//TODO Remove Duplicate "className" prop (duplicate of "customClassnames")
/**
 * Country flag
 */
const Flag = ({
  country,
  round,
  height = 20,
  className,
  holderClassName,
  componentClassname = 'flag',
  customClassnames = '',
  customStyle = '',
}: FlagProps) => {
  const getFlag = () => (
    <ReactCountryFlag
      countryCode={country}
      svg
      style={{
        fontSize: `${round ? 33 : height}px`,
      }}
    />
  );
  const getStyledFlag = () => (
    <div className={`${componentClassname}__holder ${holderClassName}`}>
      {getFlag()}
    </div>
  );
  return (
    <StyledFlag
      className={`${componentClassname} ${customClassnames} ${className}`}
      customStyle={customStyle}
    >
      {round ? getStyledFlag() : getFlag()}
    </StyledFlag>
  );
};
Flag.displayName = 'Flag';

export default Flag;
